import React, { useEffect, useRef } from "react";
import "./Head.css";
import { myPhoto, github, linkedin, downloadIcon } from "../../assets/";
import Navbar from "../Navbar/Navbar";
import Typed from "typed.js";
import "../../i18n";
import { useTranslation } from "react-i18next";

const Head = () => {
  const { t, i18n } = useTranslation();
  const typedRef = useRef(null);

  const handleDownload = () => {
    const fileUrl = "/CV.pdf";
    const anchor = document.createElement("a");
    anchor.href = fileUrl;
    anchor.download = "CV_Jakub_Michalski.pdf";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  useEffect(() => {
    const typed = new Typed(typedRef.current, {
      strings: [t("frontendDeveloper"), t("uxuidesigner"), t("programmer")],
      typeSpeed: 100,
      backSpeed: 100,
      backDelay: 1000,
      loop: true,
    });

    return () => {
      typed.destroy();
    };
  }, [t]);
  return (
    <header id="home">
      <div className="wrapper">
        <Navbar></Navbar>
        <div className="header-main">
          <section className="header-left">
            <h1>{t("text1")}</h1>
            <h2>{t("text2")}</h2>
            <span className="header-span">
              <span style={{ color: "var(--tertiary)" }}>{t("text3")}</span>
              <span ref={typedRef}></span>
            </span>
            <h3>{t("description")}</h3>
            <div class="card">
              <a
                className="socialContainer containerOne"
                href="https://github.com/michalskijakub"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={github}
                  alt="github"
                  className="socialSvg githubSvg"
                />
              </a>
              <a
                class="socialContainer containerTwo"
                href="https://www.linkedin.com/in/jmichalski00/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={linkedin}
                  alt="linkedin"
                  className="socialSvg linkedinSvg"
                />
              </a>
              <button
                type="button"
                className="button-download"
                onClick={handleDownload}
              >
                <span class="button__text">{t("download")}</span>
                <span class="button__icon">
                  <img
                    src={downloadIcon}
                    alt="download"
                    className="buttonSvg"
                  />
                </span>
              </button>
            </div>
          </section>
          <section className="header-right">
            <div className="circle">
              <img
                src={myPhoto}
                alt="Jakub Michalski"
                className="circle-image"
              />
            </div>
          </section>
        </div>
      </div>
    </header>
  );
};

export default Head;
